import { useState, useEffect } from "react";
import { FullStar, HalfStar, EmptyStar, CreatedAt } from "../../../Constants/Icons";
import charmhealthlogo_placeholder from '../../../assets/charmhealthlogo_placeholder.jpg';
import { getSignedInUser, isUserSignedIn, createReview } from '../../API/API_Handler';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../Constants/Toast';
import React from "react";

const Reviews = ({ product, reviews }) => {
    const calculateStarPercentages = (reviews) => {
        const starCounts = [0, 0, 0, 0, 0];
        reviews.forEach(review => {
            if (review.rating >= 1 && review.rating <= 5) {
                starCounts[review.rating - 1]++;
            }
        });
        const totalReviews = reviews.length;
        return starCounts.map(count => (count / totalReviews) * 100);
    };

    const sortOptions = ["Most Recent", "Highest Rating", "Lowest Rating"];

    const [sortOption, setSortOption] = useState(sortOptions[0]);

    const [isOptionModalOpen, setIsOptionModalOpen] = useState(false);
    const handleSortOptionChange = (option) => {
        setSortOption(option);
        setIsOptionModalOpen(false);
    }

    const [sortedReviews, setSortedReviews] = useState(reviews);

    useEffect(() => {
        const sorted = [...reviews];
        if (sortOption === "Most Recent") {
            setSortedReviews(sorted.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
        } else if (sortOption === "Highest Rating") {
            setSortedReviews(sorted.sort((a, b) => b.rating - a.rating));
        } else if (sortOption === "Lowest Rating") {
            setSortedReviews(sorted.sort((a, b) => a.rating - b.rating));
        }
    }, [sortOption, reviews]);

    const starPercentages = calculateStarPercentages(reviews);

    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
    const [rating, setRating] = useState(5); // Store review rating
    const [reviewContent, setReviewContent] = useState(''); // Store review content

    const handleReviewSubmit = async (e) => {
        e.preventDefault();
        const response = await createReview(product.id, product.vendor.id, rating, reviewContent); // Call the API to create a review
        setIsReviewModalOpen(false); // Close the modal after submission
    };

    async function handleLeaveReview(isReviewModalOpen) {
        if (isReviewModalOpen) {
            setIsReviewModalOpen(false);
        } else {
            const isSignedIn = await isUserSignedIn();
            if (isSignedIn) {
                setIsReviewModalOpen(true);
            } else {
                showToast(`Please sign in to leave a review!`);
            }
        }
    }

    return (
        <div className="w-full flex flex-col">
            {product && reviews && (
                <>
                    <ToastContainer />
                    {reviews.length > 0 ? (
                        <div className="w-full flex flex-col">
                            <div className="w-full flex flex-row items-center">
                                <div className="flex flex-row items-center">
                                    {[...Array(Math.floor(product.rating))].map((_, index) => (
                                        <FullStar key={`full-${index}`} />
                                    ))}
                                    {(() => {
                                        const decimal = product.rating - Math.floor(product.rating);
                                        let partialStar = null;
                                        if (decimal > 0 && decimal <= 0.3) {
                                            partialStar = <EmptyStar key="empty" />;
                                        } else if (decimal > 0.3 && decimal <= 0.7) {
                                            partialStar = <HalfStar key="half" />;
                                        } else if (decimal > 0.7) {
                                            partialStar = <FullStar key="partial-full" />;
                                        }
                                        return partialStar;
                                    })()}
                                    {[...Array(5 - Math.ceil(product.rating))].map((_, index) => (
                                        <EmptyStar key={`empty-${index}`} />
                                    ))}
                                </div>
                                <div className="font-proximanova text-[18px] mb-0 ml-3">{product.rating}</div>
                                <div className="font-proximanova text-[18px] mb-0 ml-2"> ({reviews.length})</div>
                            </div>
                            <div className="mt-3 flex flex-col">
                                {[5, 4, 3, 2, 1].map((star, index) => (
                                    <div key={star} className="w-[400px] flex items-center">
                                        <p className="w-[50px] font-proximanova text-[16px] mb-0 ">{star} star</p>
                                        <div className="flex-1 bg-white h-[8px] ml-2 rounded-full">
                                            <div
                                                className="bg-[#F2A83B] h-full rounded-full"
                                                style={{ width: `${starPercentages[star - 1]}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                ))}

                                <button className="mt-3 w-fit h-fit px-10 py-1 font-proximanova text-white text-[18px] bg-charmHover hover:text-integrationRequestTextHover rounded-full flex flex-row items-center" onClick={() => setIsOptionModalOpen(!isOptionModalOpen)}>
                                    {isOptionModalOpen ?
                                        <svg className="mr-2" width="12" height="12" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.16026 0.5L17.8205 15.5H0.5L9.16026 0.5Z" fill="#FFFFFF" />
                                        </svg>
                                        :
                                        <svg className="mr-2" width="12" height="12" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.66026 15L0 0L17.3205 0L8.66026 15Z" fill="#FFFFFF" />
                                        </svg>}
                                    {sortOption}
                                </button>

                                {isOptionModalOpen && (
                                    <div className="mt-[8px] w-fit flex flex-col border-[1px] border-charmHover">
                                        {sortOptions.map(option => (
                                            <button className="w-full px-[100px] py-[4px] font-proximanova font-[500] text-[18px] text-[#505050] mb-0 hover:bg-charmHover hover:text-white" key={option} onClick={() => handleSortOptionChange(option)}>
                                                {option}
                                            </button>
                                        ))}
                                    </div>
                                )}

                                <div className="mt-[24px] flex flex-col gap-4 ">
                                    {sortedReviews.map((review) => (
                                        <div className="flex flex-col">
                                            <div className="flex flex-col">
                                                <p className="font-proximanova text-[22px] font-[600] text-[#505050] mb-0">{review.practice_user_name}</p>
                                                <div className="mt-[4px] flex flex-row">
                                                    {[...Array(review.rating)].map((_, index) => (
                                                        <FullStar />
                                                    ))}
                                                    {[...Array(5 - review.rating)].map((_, index) => (
                                                        <EmptyStar />
                                                    ))}
                                                </div>
                                            </div>
                                            <p className="mt-[12px] font-proximanova text-[18px] text-[#505050] mb-0">{review.comment}</p>
                                            <div className="mt-[4px] flex flex-row items-center">
                                                <CreatedAt />
                                                <p className="ml-1 font-proximanova text-[15px] text-[#505050] italic mb-0">{new Date(review.created_at).toLocaleDateString()}</p>
                                            </div>

                                            {review.vendor_response &&
                                                <div className="mt-2 ml-6 flex flex-col border-l border-charmHover">
                                                    <div className="ml-4 flex flex-row items-center">
                                                        <div className="h-10 w-10 bg-charmHover rounded-full border border-charmHover">
                                                            <img
                                                                src={
                                                                    product && (product.thumbnail.includes('s3.amazonaws.com') || product.thumbnail.includes('.amazonaws.com'))
                                                                        ? product.thumbnail
                                                                        : charmhealthlogo_placeholder
                                                                }
                                                                className="min-w-10 min-h-10 max-w-10 max-h-10"
                                                            />
                                                        </div>
                                                        <p className="ml-2 font-proximanova text-[22px] font-[600] text-[#505050] mb-0">{product.vendor.company_name}</p>
                                                    </div>
                                                    <p className="mt-2 ml-4 font-proximanova text-[18px] text-[#505050] mb-0">{review.vendor_response}</p>
                                                </div>
                                            }
                                        </div>
                                    ))}
                                </div>
                                <button className='mt-[16px] w-fit h-fit mx-auto text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4' onClick={() => handleLeaveReview(isReviewModalOpen)}>
                                    Leave a Review
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="w-full flex flex-row justify-between items-center">
                            <p className="w-fit font-proximanova text-[18px] mb-0">No reviews yet for this product</p>
                            <div className="w-fit">
                                <button className='w-fit h-fit mx-auto text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4' onClick={() => handleLeaveReview(isReviewModalOpen)}>
                                    Leave a Review
                                </button>
                            </div>
                        </div>
                    )}

                    <div
                        className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ${isReviewModalOpen ? '' : 'hidden'}`}
                    >
                        <div className="p-[16px] bg-white shadow-lg w-full max-w-md">
                            <div className="flex justify-between items-center">
                                <h5 className="font-proximanova text-[22px] font-[600] text-[#505050] mb-0">Leave a Review</h5>
                                <button
                                    type="button"
                                    className="font-proximanova text-[32px] font-[600] text-[#505050] mb-0 hover:text-gray-500 focus:outline-none"
                                    onClick={() => setIsReviewModalOpen(false)}
                                >
                                    <span className="sr-only">Close</span>
                                    &times;
                                </button>
                            </div>
                            <div className="flex flex-col">
                                <form onSubmit={handleReviewSubmit}>
                                    <div className="mb-4">
                                        <label className="font-proximanova text-[18px] text-[#505050] mb-0">
                                            Rating
                                        </label>
                                        <select
                                            className="block w-full border border-[#505050] px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={rating}
                                            onChange={(e) => setRating(e.target.value)}
                                        >
                                            {[5, 4, 3, 2, 1].map((star) => (
                                                <option key={star} value={star} className="font-proximanova text-[18px] text-[#505050] mb-0">
                                                    {star} {Array(star).fill('⭐').join(' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-4">
                                        <label className="font-proximanova text-[18px] text-[#505050] mb-0">
                                            Review
                                        </label>
                                        <textarea
                                            className="block w-full border border-[#505050] px-3 py-2 focus:ring-indigo-500 focus:border-indigo-500 font-proximanova text-[18px] text-[#505050] mb-0"
                                            rows={3}
                                            value={reviewContent}
                                            onChange={(e) => setReviewContent(e.target.value)}
                                            placeholder="Write your review here..."
                                        ></textarea>
                                    </div>
                                    <div className="flex justify-end space-x-4">
                                        <button
                                            type="button"
                                            className="w-fit text-white bg-red hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-6 py-1"
                                            onClick={() => setIsReviewModalOpen(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-6 py-1">
                                            Submit Review
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </>
            )}

        </div>
    );
}

export default Reviews;